import { CompanyAPI } from '@api';

const listAnttDrivers = (params) => CompanyAPI.listAnttDrivers(params)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { listAnttDrivers };
